import React from 'react';
import './Hero.css';
import visionProImage from '../assets/images/ROBOT.png';
import VerticalDecoration from '../components/VerticalDecoration/VerticalDecoration';

const Hero = () => {
  const scrollToNextSection = () => {
    const nextSection = document.querySelector('#features') || document.querySelector('section:nth-of-type(2)');
    
    if (nextSection) {
      nextSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      window.scrollBy({
        top: window.innerHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <VerticalDecoration text="robot" />
        
        <div className="hero-content">
          
          <div className="hero-image-wrapper">
            <img 
              src={visionProImage}
              alt="Apple Vision Pro"
              className="vision-pro-image"
              loading="lazy"
            />
          </div>

          <div className="hero-footer">
            <div className="footer-left">
              <p>Bienvenue dans l’ère de l’informatique spatiale.</p>
              <p>Vous n’avez jamais rien vu de tel auparavant.</p>
              <button 
                className="btn-discover"
                onClick={scrollToNextSection}
                aria-label="Scroll to next section"
              >
                En savoir plus ↓
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;